export default "__VITE_ASSET__MTgKez5e__"